'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_main.external_api_credential', {
        url: '/company/:company_id/external_api_credential',
        template: '<external-api-credential></external-api-credential>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/external_api_credential/external_api_credential.routes.js